import { forwardRef } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment';

const CustomInputDate = forwardRef(({ value, onClick, onChange }, ref) => {
  return (<TextField
    fullWidth
    sx={{
      '& .MuiInputBase-root': {
        minHeight: '32px',
        padding: '0',
      },

      '& .MuiInputBase-input': {
        minHeight: '32px',
        padding: '4px 12px',
        boxSizing: 'border-box',
        fontSize: '15px',
        lineHeight: '1.6',
        color: '#444',
      },

      '& .MuiInputLabel-root': {
        lineHeight: '32px',
      },

      '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: '#929292',
        backgroundColor: '#efefef',
      },

      '& .MuiButtonBase-root': {
        marginRight: '4px',
        color: '#000',
      },

      '& .MuiSvgIcon-root': {
        width: '14px',
        height: '14px',
      },
    }}
    value={value}
    onClick={onClick}
    onChange={onChange}
    inputRef={ref}
    placeholder="YYYY.MM.DD"
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton>
            <CalendarTodayIcon />
          </IconButton>
        </InputAdornment>
      ),
    }}
  />);
});

export default CustomInputDate;